export const NEW = "new";
export const EXISTING = "existing";
export const REPLACEMENT = "replacement";
